import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { PAIRS } from "../data";

export const Proof = () => {
  const stageRef = useRef(null);
  const [pair, setPair] = useState(0);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const clamp = (p) => Math.min(96, Math.max(4, p));
  const fromX = (x) => {
    const r = stageRef.current.getBoundingClientRect();
    setPos(clamp(((x - r.left) / r.width) * 100));
  };

  useEffect(() => {
    const up = () => (dragging.current = false);
    window.addEventListener("pointerup", up);
    return () => window.removeEventListener("pointerup", up);
  }, []);

  const p = PAIRS[pair];
  return (
    <section id="proof" className="section" data-testid="proof-section">
      <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}>
        <p className="eyebrow">Before &amp; after on Kaua'i</p>
        <h2 className="h2">Real properties.<br />Real results.</h2>
        <p className="sub">Drag the divider. Overgrown lots cleared, ponds revived — this is what property care on Kaua'i actually looks like.</p>
      </motion.div>
      <div
        className="proof-stage"
        ref={stageRef}
        onPointerDown={(e) => { dragging.current = true; e.currentTarget.setPointerCapture?.(e.pointerId); fromX(e.clientX); }}
        onPointerMove={(e) => { if (dragging.current) fromX(e.clientX); }}
        data-testid="proof-slider-stage"
      >
        <img className="proof-img" src={p.before} alt={p.label + " on Kaua'i, before"} />
        <img className="proof-img" src={p.after} alt={p.label + " on Kaua'i, after"} style={{ clipPath: `inset(0 0 0 ${pos}%)` }} />
        <div className="divider" style={{ left: pos + "%" }} aria-hidden="true" />
        <div
          className="knob"
          style={{ left: pos + "%" }}
          role="slider"
          aria-label="Reveal the after photo"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={Math.round(pos)}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "ArrowLeft") setPos((v) => clamp(v - 4));
            if (e.key === "ArrowRight") setPos((v) => clamp(v + 4));
          }}
          data-testid="proof-slider-knob"
        >
          &lt;&gt;
        </div>
        <span className="ptag b">Before</span><span className="ptag a">After</span>
      </div>
      <div className="picker">
        {PAIRS.map((x, i) => (
          <button key={x.label} type="button" className={"pick" + (i === pair ? " on" : "")} onClick={() => { setPair(i); setPos(50); }} data-testid={`proof-pick-${i}`}>
            {x.label}
          </button>
        ))}
      </div>
    </section>
  );
};
